/** Daily streak: play on consecutive days (Accra time). One missed day a week is forgiven. */
export interface Streak {
  count: number;
  lastDay: string | null;
  /** ISO date of the last forgiven gap, so it only happens once a week. */
  graceUsed: string | null;
}

const DAY = 86_400_000;

export function dayKey(time: number): string {
  return new Date(time).toISOString().slice(0, 10);
}

function daysBetween(a: string, b: string): number {
  return Math.round((Date.parse(b) - Date.parse(a)) / DAY);
}

export function bumpStreak(streak: Streak, now: number): Streak {
  const today = dayKey(now);
  if (streak.lastDay === today) return streak;
  if (!streak.lastDay) return { count: 1, lastDay: today, graceUsed: streak.graceUsed };
  const gap = daysBetween(streak.lastDay, today);
  if (gap === 1) return { ...streak, count: streak.count + 1, lastDay: today };
  const graceFree = !streak.graceUsed || daysBetween(streak.graceUsed, today) >= 7;
  if (gap === 2 && graceFree) return { count: streak.count + 1, lastDay: today, graceUsed: today };
  return { count: 1, lastDay: today, graceUsed: streak.graceUsed };
}

/** Still alive today (played today or yesterday)? */
export function currentStreak(streak: Streak, now: number): number {
  if (!streak.lastDay) return 0;
  return daysBetween(streak.lastDay, dayKey(now)) <= 1 ? streak.count : 0;
}
